// extracted by mini-css-extract-plugin
export default {"configGroup":"ChooseTwoValues_configGroup__yIyJg","configLabel":"ChooseTwoValues_configLabel__MLrQp","configItem":"ChooseTwoValues_configItem__MAizQ"};